module.exports = __webpack_public_path__ + "media/images/sports_icons/playground-b99ae35c0c3d05bf5e5a4f8241e8c470.png";